import CHIPS_Autocycle from "./components/chips-autocycle.js";
import CHIPS_Swiper from "./components/chips-swiperjs.js";
import CHIPS_Swipefree from "./components/chips-swipefree.js";
import CHIPS_jpgcover from "./components/chips-jpgcover.js";
import CHIPS_AccordionPlus from "./components/chips-accordionplus.js";
import CHIPS_GluckWorkFilters from "./components/chips-workfilters.js";
import chipsInview from "./components/chips-inview.js";

class App {
	constructor(options) {
		this.defaults = {
			defaultK: false,
		};
		this.options = {};
		this.baseQueryEl = document;
		Object.assign(this.options, this.defaults, options);

		this.namespace = "App";
		this.init();
	}

	init() {
		this.initUI();
		window.onload = () => {
			this.initAutoCycleGalleries();
			this.readmoreUI();
			this.initSwiperGalleries();
			this.initModalGalleries();
			this.initVideos();
			this.initAccordionPlus();
			this.initBackToTop();
			this.initWorkFilters();
			this.initPeopleFilters();
			this.initInview();
			/* TODO try and get page swap working from 
				https://view-transitions.netlify.app/profiles/mpa/
				https://developer.mozilla.org/en-US/docs/Web/API/Window/pageswap_event
			*/
		};
	}

	initCB(targetEl) {
		if (targetEl) {
			this.baseQueryEl = targetEl;

			this.initUI();
			this.initAutoCycleGalleries();
			this.readmoreUI();
			this.initSwiperGalleries();
			this.initModalGalleries();
			this.initVideos();
			this.initWorkFilters();
			this.initPeopleFilters();
			this.initInview();
		}
	}

	initUI() {
		const appScope = this;
		const $panelMenuClose =
			this.baseQueryEl.querySelector(".panel__menu-close");
		if ($panelMenuClose) {
			$panelMenuClose.addEventListener("click", () => {
				const $panelMenu = document.querySelector("#panel__menu");
				// const $panelMenu =
				// 	this.baseQueryEl.querySelector("#panel__menu");
				if ($panelMenu) {
					setTimeout(function () {
						document
							.querySelector("#panel__menu")
							.setAttribute("hidden", "");
					}, 100);
					// $panelMenu.hidePopover();
					$panelMenu.setAttribute("hidden", "");
				}
			});
		}

		const $panelMenuToggle = this.baseQueryEl.querySelector(
			".gluckplus__menu-toggle"
		);
		if ($panelMenuToggle) {
			$panelMenuToggle.addEventListener("click", () => {
				const $panelMenu = document.querySelector("#panel__menu");
				if ($panelMenu) {
					$panelMenu.removeAttribute("hidden");
					// $panelMenu.showPopover();
				}
			});
		}

		const $dynamicCards =
			this.baseQueryEl.querySelectorAll(".card--dynamic");
		if ($dynamicCards && $dynamicCards.length) {
			$dynamicCards.forEach((el) => {
				const $links = el.querySelectorAll("a");
				$links.forEach((subEl) => {
					subEl.addEventListener("click", (e) => {
						e.preventDefault();
						const $article = subEl.closest("article");
						// const $content = $article.querySelector(".card__content");
						const url = subEl.getAttribute("href");
						const rellink = subEl.getAttribute("data-rellink");
						if (rellink) {
							history.pushState({}, "", rellink);
						}
						// $article.innerHTML = "Loading...";
						if (!$article.classList.contains("story--dynload")) {
							$article.classList.add("loading");
							fetch(url)
								.then((response) => response.text())
								.then((html) => {
									$article.classList.add("story--full");
									$article.classList.remove("loading");
									// parse the HTML, and only keep the root level <section> elements
									const parser = new DOMParser();
									const doc = parser.parseFromString(
										html,
										"text/html"
									);
									const $sections =
										doc.querySelectorAll("section");
									let OutHTML = "";
									$sections.forEach(($section) => {
										OutHTML += $section.outerHTML;
									});

									$article.querySelector(
										".contents--loaded"
									).innerHTML =
										OutHTML +
										'<div class="scrollto__anchor"></div>';
									$article.classList.add("story--dynload");

									setTimeout(function () {
										const $title = $article.querySelector(
											".contents--loaded .scrollto__anchor"
										);
										if ($title) {
											$title.scrollIntoView({
												behavior: "smooth",
											});
										}
									}, 200);
									setTimeout(function () {
										appScope.initCB(
											$article.querySelector(
												".contents--loaded"
											)
										);

										const $closeBtns =
											$article.querySelectorAll(
												".dyncard--close"
											);
										$closeBtns.forEach((subEl) => {
											subEl.addEventListener(
												"click",
												(e) => {
													e.preventDefault();
													const $articleWrapper =
														subEl.closest(
															"article.card--dynamic"
														);
													$articleWrapper.classList.remove(
														"story--full"
													);

													if (
														el.querySelector(
															"iframe[src*='vimeo.com']"
														)
													) {
														const $iframes =
															el.querySelectorAll(
																"iframe[src*='vimeo.com']"
															);
														$iframes.forEach(
															($iframe) => {
																$iframe.contentWindow.postMessage(
																	'{"method":"pause"}',
																	"https://player.vimeo.com"
																);
															}
														);
													}

													setTimeout(function () {
														const $title = $article;
														if ($title) {
															$title.scrollIntoView(
																{
																	behavior:
																		"smooth",
																}
															);
														}
													}, 200);
												}
											);
										});
									}, 500);
								});
						} else {
							$article.classList.add("story--full");
						}
					});
				});

				// find all .dyncard--close elements and add a click event, which will remove the .story--full and .loading classes on the closest article
				const $closeBtns = el.querySelectorAll(".dyncard--close");
				$closeBtns.forEach((subEl) => {
					subEl.addEventListener("click", (e) => {
						e.preventDefault();
						const $article = subEl.closest("article");
						$article.classList.remove("story--full");

						if (el.querySelector("iframe[src*='vimeo.com']")) {
							const $iframes = el.querySelectorAll(
								"iframe[src*='vimeo.com']"
							);
							$iframes.forEach(($iframe) => {
								$iframe.contentWindow.postMessage(
									'{"method":"pause"}',
									"https://player.vimeo.com"
								);
							});
						}
					});
				});

				if (
					el.closest("article").classList.contains("autoload-story")
				) {
					const $firstLink = el.querySelector("a");
					if ($firstLink) {
						$firstLink.click();
					}
				}
			});
		}

		const $dynamicCardsPerson = this.baseQueryEl.querySelectorAll(
			".card--dynamicperson"
		);
		if ($dynamicCardsPerson && $dynamicCardsPerson.length) {
			$dynamicCardsPerson.forEach((el) => {
				const $links = el.querySelectorAll("a");
				$links.forEach((subEl) => {
					subEl.addEventListener("click", (e) => {
						e.preventDefault();
						const $article = subEl.closest("article");
						// const $content = $article.querySelector(".card__content");
						const url = subEl.getAttribute("href");
						const rellink = subEl.getAttribute("data-rellink");
						if (rellink) {
							history.pushState({}, "", rellink);
						}
						// $article.innerHTML = "Loading...";
						if (!$article.classList.contains("person--dynload")) {
							$article.classList.add("loading");
							fetch(url)
								.then((response) => response.text())
								.then((html) => {
									$article.classList.add("person--full");
									$article.classList.remove("loading");
									// parse the HTML, and only keep the root level <section> elements
									const parser = new DOMParser();
									const doc = parser.parseFromString(
										html,
										"text/html"
									);
									const $sections =
										doc.querySelectorAll(
											".person__wrapper"
										);
									let OutHTML = "";
									$sections.forEach(($section) => {
										OutHTML += $section.outerHTML;
									});

									$article.querySelector(
										".contents--loaded"
									).innerHTML =
										OutHTML +
										'<div class="scrollto__anchor"></div>';
									$article.classList.add("person--dynload");

									setTimeout(function () {
										const $title = $article.querySelector(
											".contents--loaded .scrollto__anchor"
										);
										if ($title) {
											$title.scrollIntoView({
												behavior: "smooth",
											});
										}
									}, 200);

									setTimeout(function () {
										appScope.initCB(
											$article.querySelector(
												".contents--loaded"
											)
										);
									}, 500);
								});
						} else {
							$article.classList.add("person--full");
						}
					});
				});

				// find all .dyncard--close elements and add a click event, which will remove the .story--full and .loading classes on the closest article
				const $closeBtns = el.querySelectorAll(".dyncard--close");
				$closeBtns.forEach((subEl) => {
					subEl.addEventListener("click", (e) => {
						e.preventDefault();
						const $article = subEl.closest("article");
						$article.classList.remove("story--full");
						$article.classList.remove("person--full");
					});
				});

				if (
					el.closest("article").classList.contains("autoload-story")
				) {
					const $firstLink = el.querySelector("a");
					if ($firstLink) {
						$firstLink.click();
					}
				}
			});
		}

		const $clipboardButtons = this.baseQueryEl.querySelectorAll(
			".link__button--clipboard"
		);
		if ($clipboardButtons && $clipboardButtons.length) {
			$clipboardButtons.forEach((el) => {
				el.addEventListener("click", () => {
					const text = el.getAttribute("data-url");
					navigator.clipboard.writeText(text).then(
						() => {
							console.log("Copied to clipboard");
						},
						(err) => {
							console.error("Failed to copy to clipboard", err);
						}
					);
					el.querySelector("span").textContent = "Copied";
				});
			});
		}

		const $revealHidden =
			this.baseQueryEl.querySelectorAll(".reveal_hidden");
		if ($revealHidden && $revealHidden.length) {
			$revealHidden.forEach((el) => {
				el.addEventListener("click", () => {
					el.remove();
					const $awaitReveal =
						this.baseQueryEl.querySelectorAll(".await__reveal");
					if ($awaitReveal && $awaitReveal.length) {
						$awaitReveal.forEach((subEl) => {
							subEl.classList.remove("await__reveal");
						});
					}
				});
			});
		}

		// if there is a .scroll__assist element, check if the user has scrolled the page. if they have scrolled more than 20px, add a class .has-scrolled to .scroll__assist
		const $scrollAssist = this.baseQueryEl.querySelector(".scroll__assist");
		if ($scrollAssist) {
			let watchScroll = true;
			window.addEventListener("scroll", () => {
				if (!watchScroll) return;
				if (window.scrollY > 20) {
					$scrollAssist.classList.add("has-scrolled");
					watchScroll = false;
					// } else {
					// 	$scrollAssist.classList.remove("has-scrolled");
				}
			});

			$scrollAssist.addEventListener("click", () => {
				window.scrollTo({
					top: window.innerHeight * 0.75,
					behavior: "smooth",
				});
			});
		}

		// const $filterForms = this.baseQueryEl.querySelectorAll(".filter__form");
		// if ($filterForms && $filterForms.length) {
		// 	$filterForms.forEach((el) => {
		// 		el.addEventListener("submit", (e) => {
		// 			console.log(el);
		// 			e.preventDefault();
		// 			const valMin = el.querySelector("input[name='size_min']");
		// 			const valMax = el.querySelector("input[name='size_max']");

		// 			if (el.classList.contains("filter__form--size")) {
		// 				if (valMin && valMax) {
		// 					const url = `/our-work/size/${valMin.value}/${valMax.value}`;
		// 					window.location.href = url;
		// 				}
		// 			} else if (el.classList.contains("filter__form--year")) {
		// 				if (valMin && valMax) {
		// 					const url = `/our-work/year/${valMin.value}/${valMax.value}`;
		// 					window.location.href = url;
		// 				}
		// 			} else if (
		// 				el.classList.contains("filter__form--location")
		// 			) {
		// 				if (valMin && valMax) {
		// 					const url = `/our-work/location/${valMin.value}/${valMax.value}`;
		// 					window.location.href = url;
		// 				}
		// 			}
		// 		});
		// 	});
		// }

		// const $filterLabels = this.baseQueryEl.querySelectorAll(
		// 	".filter__block > label"
		// );
		// if ($filterLabels && $filterLabels.length) {
		// 	$filterLabels.forEach((subEl) => {
		// 		subEl.addEventListener("click", (e) => {
		// 			const targetInputSelector = subEl.getAttribute("for");
		// 			const targetInput = this.baseQueryEl.querySelector(
		// 				"#" + targetInputSelector
		// 			);
		// 			if (targetInput.checked) {
		// 				targetInput.checked = false;
		// 			}
		// 		});
		// 	});
		// }
	}

	initAutoCycleGalleries() {
		const autocycleEls =
			this.baseQueryEl.querySelectorAll(".img__autocycle");
		if (autocycleEls && autocycleEls.length > 0) {
			autocycleEls.forEach((el) => {
				const autocycle = new CHIPS_Autocycle({ $el: el });
			});
		}
	}

	readmoreUI() {
		const $el = this.baseQueryEl.querySelectorAll(".readmore__toggle");
		if ($el && $el.length) {
			$el.forEach((el) => {
				el.addEventListener("click", () => {
					el.closest("article")
						.querySelector(".readmore__content")
						.classList.add("vis");
					el.remove();
				});
			});
		}
	}

	initModalGalleries() {
		const $modalClose = this.baseQueryEl.querySelectorAll(
			".gallery__modal--close"
		);
		if ($modalClose && $modalClose.length) {
			$modalClose.forEach((el) => {
				el.addEventListener("click", () => {
					el.closest(".gallery__modal").classList.remove("is-active");
				});
			});
		}
	}

	initSwiperGalleries() {
		const swiperEls = this.baseQueryEl.querySelectorAll(".swiper");
		if (swiperEls && swiperEls.length > 0) {
			swiperEls.forEach((el) => {
				const swiper = new CHIPS_Swiper({ $el: el });
			});
		}

		const swipefreeEls = this.baseQueryEl.querySelectorAll(".swipefree");
		if (swipefreeEls && swipefreeEls.length > 0) {
			swipefreeEls.forEach((el) => {
				const swipefree = new CHIPS_Swipefree({ $el: el });
			});
		}
	}

	initVideos() {
		const jpgCoverEls = this.baseQueryEl.querySelectorAll(".jpg-cover");
		if (jpgCoverEls && jpgCoverEls.length > 0) {
			jpgCoverEls.forEach((el) => {
				const jpgCoverEl = new CHIPS_jpgcover({ $el: el });
			});
		}

		const pauseBtns = this.baseQueryEl.querySelectorAll(
			".video__button--pause"
		);
		if (pauseBtns && pauseBtns.length > 0) {
			pauseBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".figure__media")
						.classList.add("vid-paused");
					const videoEl = scopeEl
						.closest(".figure__media")
						.querySelector("iframe");
					videoEl.contentWindow.postMessage(
						'{"method":"pause"}',
						"https://player.vimeo.com"
					);
				});
			});
		}

		const playBtns = this.baseQueryEl.querySelectorAll(
			".video__button--play"
		);
		if (playBtns && playBtns.length > 0) {
			playBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".figure__media")
						.classList.remove("vid-paused");
					const videoEl = scopeEl
						.closest(".figure__media")
						.querySelector("iframe");
					videoEl.contentWindow.postMessage(
						'{"method":"play"}',
						"https://player.vimeo.com"
					);
				});
			});
		}

		const infoBtns = this.baseQueryEl.querySelectorAll(
			".button-info-wrap button"
		);
		if (infoBtns && infoBtns.length > 0) {
			infoBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".figure__media")
						.classList.toggle("vid-info-on");
				});
			});
		}

		// for each video-teaser element, add a mouseover event
		// during the mouseover event, if there is a '.teaser__vid' element, add the 'teaser__vid--hover' class
		// during the mouseout event, remove the 'teaser__vid--hover' class
		// if there is not a .video-teaser element, create one
		// the markup should be a video tag with the src of the element.querySelector's card data-video attribute
		// the video tag should have the 'autoplay' and 'muted' attribute
		// the video tag should be appended to the element
		// const videoTeasers = this.baseQueryEl.querySelectorAll(".video-teaser");

		// if (videoTeasers && videoTeasers.length) {
		// 	videoTeasers.forEach((el) => {
		// 		el.addEventListener("mouseover", () => {
		// 			const vidTeaser = el.querySelector(".teaser__vid");
		// 			if (vidTeaser) {
		// 				vidTeaser.classList.add("teaser__vid--hover");
		// 			} else {
		// 				const videoSrc = el.getAttribute("data-video");
		// 				if (videoSrc === null) return;
		// 				const videoEl = document.createElement("video");
		// 				videoEl.setAttribute("autoplay", "");
		// 				videoEl.setAttribute("muted", "");
		// 				videoEl.setAttribute("loop", "");
		// 				videoEl.setAttribute("controls", "");
		// 				videoEl.setAttribute("playsinline", "");
		// 				videoEl.setAttribute("class", "teaser__vid");
		// 				videoEl.innerHTML = `<source src="${videoSrc}" type="video/mp4">`;
		// 				el.querySelector("figure").appendChild(videoEl);
		// 			}
		// 		});

		// 		el.addEventListener("mouseout", () => {
		// 			const vidTeaser = el.querySelector(".teaser__vid");
		// 			if (vidTeaser) {
		// 				vidTeaser.classList.remove("teaser__vid--hover");
		// 			}
		// 		});
		// 	});
		// }
	}

	initAccordionPlus() {
		const accordionPlusEls = document.querySelectorAll(
			".accordion__wrap details"
		);
		if (accordionPlusEls.length <= 0) {
			return;
		}
		accordionPlusEls.forEach((el) => {
			const accordionPlusEl = new CHIPS_AccordionPlus({ $el: el });
		});
	}
	initBackToTop() {
		window.addEventListener("scroll", () => {
			const backToTopEl = document.querySelector(".back__to__top");
			if (!backToTopEl) {
				return;
			}
			if (window.scrollY > window.innerHeight * 1) {
				backToTopEl.classList.add("scroll-in");
			} else {
				backToTopEl.classList.remove("scroll-in");
			}
		});

		const backToTopEl = document.querySelector(".back__to__top");
		if (!backToTopEl) {
			return;
		}
		backToTopEl.addEventListener("click", () => {
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}

	initWorkFilters() {
		window.rangeFunctions = [];
		const $workFilters = document.querySelector(".work__filters");
		if ($workFilters) {
			const workFilters = new CHIPS_GluckWorkFilters({
				$el: $workFilters,
			});
		}
	}

	initPeopleFilters() {
		// every time a .people__filter-buttons .link__button is clicked, get the data-filter attribute
		// then, get all .people__card elements
		// if the data-filter attribute is 'all', show all .people__card elements
		// otherwise, hide all .people__card elements
		// then, show all .people__card elements with the data-filter attribute
		const $filterButtons = document.querySelectorAll(
			".people__filter-buttons .link__button"
		);
		if ($filterButtons && $filterButtons.length) {
			$filterButtons.forEach((el) => {
				el.addEventListener("click", (e) => {
					// e.preventDefault();
					const filter = el.getAttribute("data-filter");
					const $peopleCards =
						document.querySelectorAll(".people__card");
					if (filter === "all" || filter === "*") {
						$peopleCards.forEach((subEl) => {
							subEl.classList.remove("hide");
						});
					} else {
						// console.log(filter);
						$peopleCards.forEach((subEl) => {
							subEl.classList.add("hide");
						});
						const $filteredCards = document.querySelectorAll(
							`.people__card.${filter}`
						);
						$filteredCards.forEach((subEl) => {
							subEl.classList.remove("hide");
						});
					}

					// .filters--people .active remove .active, add active to the clicked element
					const $filterButtons = document.querySelectorAll(
						".people__filter-buttons .link__button"
					);
					if ($filterButtons && $filterButtons.length) {
						$filterButtons.forEach((subEl) => {
							subEl.classList.remove("active");
						});
					}
					el.classList.add("active");
				});
			});
		}
	}

	initInview() {
		const ivEls = this.baseQueryEl.querySelectorAll(
			".iv,.card__landing,.card--in,.row-flex"
		);
		if (ivEls && ivEls.length > 0) {
			ivEls.forEach((el) => {
				const ivEl = new chipsInview({ $el: el });
			});
		}
	}
}

const app = new App();
